import { useCurrentUser } from '@hooks/useCurrentUser'
import { AlbatrossIcon, Box, ChevronRightIcon, tss } from '@ds/components'
import { ReactElement } from 'react'
import EnhancedLink from '@components/EnhancedLink'

const useStyles = tss.create(({ theme }) => ({
    link: {
        display: 'block',
        marginLeft: theme.spacing(1),
    },

    albatrossIcon: {
        display: 'block',
        marginRight: theme.spacing(1),
        lineHeight: 1,
    },

    withMobileNavBar: {
        top: '56px',
    },

    headerPromotion: {
        position: 'absolute',
        top: '100%',
        right: 0,
        display: 'flex',
        alignItems: 'center',
        padding: '5px 7px',
        borderRadius: '0 0 4px 4px',
        borderBottom: '1px solid #e6e6e6',
        backgroundColor: '#fff',
        boxShadow: '0 5px 5px -3px #e6e6e6',
        color: '#1e70a1',
    },
}))

export default function BasicNavPromotion(): ReactElement | null {
    const currentUser = useCurrentUser().data
    const { classes } = useStyles()

    if (!currentUser || currentUser.isPremium) {
        return null
    }

    return (
        <>
            <Box className={classes.headerPromotion}>
                <AlbatrossIcon color="primary.main" />
                <EnhancedLink
                    to="https://www.internations.org/subscription?ref=ms_ul_mhb&upgradeTrigger=ut:my_account/flyout"
                    className={classes.link}
                >
                    Upgrade to Albatross
                </EnhancedLink>
                <ChevronRightIcon color="warning.main" />
            </Box>
        </>
    )
}

export { BasicNavPromotion }
